import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { LombardFacade } from '@zero/lombard/domain';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'lombard-teaser',
  templateUrl: './lombard-teaser.component.html',
  styleUrls: ['./lombard-teaser.component.scss'],
  imports: [CommonModule, RouterLink, TranslocoPipe],
})
export class LombardTeaserComponent {
  public readonly facade = inject(LombardFacade);
  public readonly lombardUrl = commonRoutes.postlogin.lombard;
}
